/* ONDE — Early Black Friday : couche URGENCE. Vrai compte à rebours (date de fin réelle), aucun faux stock.
   Fait : texte du bandeau qui monte en pression, titre de l'onglet, bandeaux d'urgence (fiche produit, créateur de pack), pastille flottante (ordinateur) posée juste au-dessus de la barre collante. */
(function(){
  var root=document.documentElement;
  if(!root.classList.contains('onde-bf'))return;
  var bar=document.querySelector('[data-bf-bar]');
  if(!bar)return;
  var start=parseInt(bar.getAttribute('data-bf-start'),10)||0;
  var end=parseInt(bar.getAttribute('data-bf-end'),10)||0;
  if(!end)return;
  var pv=/[?&]bf=preview/.test(location.search);
  function pad(n){return n<10?'0'+n:''+n;}
  function fmt(s){var d=Math.floor(s/86400),h=Math.floor((s%86400)/3600),m=Math.floor((s%3600)/60),x=s%60;return (d>0?d+'j ':'')+pad(h)+':'+pad(m)+':'+pad(x);}
  var endTxt='';
  try{endTxt=new Date(end).toLocaleDateString('fr-FR',{day:'2-digit',month:'2-digit',timeZone:'Europe/Paris'});}catch(e){}
  var origTitle=document.title;
  var floatEl=null,built=false;

  function mk(cls,extra){
    var el=document.createElement('div');
    el.className='bf-u '+cls;
    el.innerHTML='<span data-bf-head></span><span>il reste</span><b data-bf-timer></b>'+(extra?'<small>'+extra+'</small>':'');
    return el;
  }
  function build(){
    /* fiche produit : avant la 1re offre */
    if(!document.querySelector('.bf-u--offers')){
      var lab=document.querySelector('label.offer');
      if(lab&&lab.parentNode)lab.parentNode.insertBefore(mk('bf-u--offers','Après, retour au prix normal. Pas de prolongation.'),lab);
    }
    /* créateur de pack (l'accueil a déjà son propre compte à rebours géant) */
    var bt=document.querySelector('.obfb__head');
    if(bt&&!bt.querySelector('.bf-u--pack')){
      var ti=bt.querySelector('.obfb__title');
      bt.insertBefore(mk('bf-u--pack',''),ti||null);
    }
    /* pastille flottante (masquée en CSS sur mobile) */
    if(!floatEl){
      var cta=bar.querySelector('.bf-bar__cta[data-bf-live]');
      var href=document.getElementById('composer')?'#composer':(cta?cta.getAttribute('href'):'/');
      floatEl=document.createElement('a');
      floatEl.className='bf-float';
      floatEl.href=href;
      floatEl.innerHTML='<span data-bf-head></span><b data-bf-timer></b>';
      document.body.appendChild(floatEl);
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(en){floatEl.classList.toggle('is-on',!en[0].isIntersecting);}).observe(bar);
      }else{
        window.addEventListener('scroll',function(){floatEl.classList.toggle('is-on',window.scrollY>300);},{passive:true});
      }
    }
    built=true;
  }

  /* pose la pastille juste au-dessus de la barre collante du bas (barre d'achat de l'accueil / de la fiche produit) */
  function fixedAncestor(el){
    while(el&&el!==document.body&&el!==document.documentElement){
      if(getComputedStyle(el).position==='fixed')return el;
      el=el.parentElement;
    }
    return null;
  }
  function placeFloat(){
    if(!floatEl)return;
    var vh=window.innerHeight,off=0;
    document.querySelectorAll('.oh-sticky,[data-sticky-atc],[class*="sticky-atc"],[class*="sticky-bar"],[class*="stickybar"]').forEach(function(n){
      var f=fixedAncestor(n);
      if(!f||f===floatEl)return;
      var r=f.getBoundingClientRect();
      if(r.height<20||r.top>=vh-4||r.bottom<vh-6)return;
      off=Math.max(off,vh-r.top);
    });
    var b=(off>0?off+14:14)+'px';
    if(floatEl.style.bottom!==b)floatEl.style.bottom=b;
  }

  function tick(){
    var now=Date.now();
    if(now>=end){
      document.title=origTitle;
      document.querySelectorAll('.bf-u,.bf-float').forEach(function(e){e.remove();});
      root.removeAttribute('data-bf-lvl');
      return false;
    }
    if(!(pv||now>=start))return true;
    var s=Math.max(0,Math.floor((end-now)/1000));
    var lvl=s<3600?4:(s<86400?3:(s<259200?2:1));
    root.setAttribute('data-bf-lvl',String(lvl));
    var t=fmt(s);
    var head=lvl===4?'🚨 DERNIÈRES MINUTES':(lvl===3?'🚨 DERNIÈRES HEURES':(lvl===2?'⚠️ DERNIERS JOURS':'🔥 PRIX CASSÉS'));
    if(!built||(!document.querySelector('.bf-u--offers')&&document.querySelector('label.offer')))build();
    document.querySelectorAll('[data-bf-timer]').forEach(function(e){if(e.textContent!==t)e.textContent=t;});
    document.querySelectorAll('[data-bf-head]').forEach(function(e){if(e.textContent!==head)e.textContent=head;});
    var bt=bar.querySelector('.bf-bar__txt [data-bf-live]');
    if(bt){
      var msg=head+' · jusqu\'au '+endTxt+' à minuit · fin dans';
      if(bt.textContent!==msg)bt.textContent=msg;
    }
    placeFloat();
    if(document.hidden){
      document.title=(s%2?'🚨 Il reste '+t+' !':'⏰ Early Black Friday · '+t);
    }else{
      var nt='⏰ '+t+' · '+origTitle.replace(/^(⏰|🚨)[^·]*·\s*/,'');
      if(document.title!==nt)document.title=nt;
    }
    return true;
  }
  if(tick()){
    var iv=setInterval(function(){if(!tick())clearInterval(iv);},1000);
    document.addEventListener('visibilitychange',tick);
    window.addEventListener('scroll',placeFloat,{passive:true});
    window.addEventListener('resize',placeFloat);
    if(window.MutationObserver){
      var sched=0;
      new MutationObserver(function(){if(sched)return;sched=setTimeout(function(){sched=0;build();placeFloat();},300);}).observe(document.body,{childList:true,subtree:true});
    }
  }
})();
